import { faClock, faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getAllOrders } from '../../../../api/shop.api'
import DashboardCard from '../components/DashboardCard'
import SkeletonLoader from '../components/SkeletonLoader'
import StatCard from '../components/StatCard'
import { ShopStatsData } from '../types/widget-data.type'

const ShopStatsWidget = () => {
    const { t } = useTranslation()

    const { data: orders, isLoading } = useQuery({
        queryKey: ['orders'],
        queryFn: getAllOrders,
    })

    if (isLoading) {
        return <SkeletonLoader showHeader itemCount={2} itemHeight="60px" />
    }

    const ordersArray = Array.isArray(orders) ? orders : []

    const data: ShopStatsData = {
        totalOrders: ordersArray.length || 0,
        pendingOrders: ordersArray.filter((o: any) => o.status === 'PENDING').length || 0,
        revenueThisMonth: 0,
        topProducts: [],
    }

    return (
        <DashboardCard
            title={t('adminDashboard.widgets.shopStats.title')}
            icon={<FontAwesomeIcon icon={faShoppingCart} />}
        >
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
                <StatCard
                    label={t('adminDashboard.widgets.shopStats.totalOrders')}
                    value={data.totalOrders}
                    icon={<FontAwesomeIcon icon={faShoppingCart} />}
                    color="blue"
                />
                <StatCard
                    label={t('adminDashboard.widgets.shopStats.pendingOrders')}
                    value={data.pendingOrders}
                    icon={<FontAwesomeIcon icon={faClock} />}
                    color="yellow"
                />
            </div>
        </DashboardCard>
    )
}

export default ShopStatsWidget
